import { Component, Input, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { AddressPickerComponent } from '../../../../../../../shared/components/address-picker/address-picker.component';
import { JobTypeEnum } from '../../../../../../../shared/Container/enum/JobTypeEnum';
import { AbstractContainerJobTypeHelper } from '../../../../../../../shared/Container/Helper/AbstractContainerJobTypeHelper';
import { CommonModule } from '@angular/common';
import { SiteContactComponent } from '../../../../../../../shared/components/site-contact/site-contact.component';

@Component({
  selector: 'app-container-job-address-form',
  standalone: true,
  imports: [AddressPickerComponent, CommonModule, ReactiveFormsModule, SiteContactComponent],
  templateUrl: './container-job-address-form.component.html',
  styleUrl: './container-job-address-form.component.scss'
})
export class ContainerJobAddressFormComponent {

  @ViewChild('addressPicker') childComponent!: AddressPickerComponent;

  @Input()
  label: string = "";

  @Input()
  placeholder: string = "";

  @Input()
  jobType!: JobTypeEnum | null;

  @Input()
  formGroup!: FormGroup | null;

  abstractContainerJobTypeHelper!: AbstractContainerJobTypeHelper | null;
  isInitialized: boolean = false;

  constructor(
    private readonly fb: FormBuilder
  ) { }

  ngOnInit() {
    this.isInitialized = false;
    this.abstractContainerJobTypeHelper = new AbstractContainerJobTypeHelper();

    if (this.formGroup === null) {
      throw new Error('formGroup is required');
    }else{
      if (this.formGroup?.value?.address?.addressSelection?.masterContactAddressId?.masterContactId && this.formGroup?.value?.address?.addressSelection?.masterContactAddressId?.masterContactId > 0) {
        this.isInitialized = true;
        return;
      } else {
        this.formGroup.setControl('address', this.fb.group({
          addressSelection: this.fb.group({}),
        }));
      }
    }
    this.isInitialized = true;
  }

  getFormPartial = (groupPath: string) => this.formGroup!.get(groupPath) as FormGroup;
}
